import { render, staticRenderFns } from "./SectionList.vue?vue&type=template&id=69172ad4"
import script from "./SectionList.vue?vue&type=script&lang=js"
export * from "./SectionList.vue?vue&type=script&lang=js"
import style0 from "./SectionList.vue?vue&type=style&index=0&id=69172ad4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports